export default __webpack_public_path__ + "img/012dc682d90511864d62645903edddc2.jpg";